// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map {
    height: 80vh;
    width: 100%;
    /**width: 94em;*/
    z-index: 0;
}

.map-error{
    z-index: 1;
    position: absolute;
    top: 20%;
    right: 42%;
    left: 42%;
    width: 200px;
    height: 100px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #3836361a;
    border-radius: 6px;
    opacity: 1; 
    text-align: center;
    padding-top: 3%;
    color: #2C906B;
    font-size: 16px;
    font-weight: bold;
}

.ol-full-screen{
    right: .5em !important;
    top: 20em !important;
    position: absolute;
}

.ol-zoom{
    right: .5em !important;
    top: 22em !important;
    left: unset;
    position: absolute;
}

.location-container:fullscreen {
    height: 100%;
}

.location-container:fullscreen .map{
    height: 100vh !important;
}

.location-container{
    display: flex;
    position: relative;
    width: 100%;
}

.legend {
    z-index: 1;
    position: absolute;
    top: 30px;
    right: 10px;
    width: 250px;
    height: 250px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border-radius: 6px;
    opacity: 1; 
}

.legendDiv{
    z-index: 1;
    position: absolute;
    top: 30px;
    right: 10px;
    width: 133px;
    height: 58px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border-radius: 6px;
    opacity: 1; 
    display: block;
    padding: 10px 0px 10px 0px;

}

.legendLbl{
    cursor: pointer;
    /* margin-left: 5px; */
    color: #2C906B;
    font-weight: bold;
}

.text-desc{
    width: 65px;
    height: 19px;
    /* color: var(--unnamed-color-2c906b); */
    text-align: left;
    /* font: normal normal bold 16px/19px Helvetica Neue; */
    letter-spacing: 0px;
    color: #2C906B;
    opacity: 1;
    margin-left: 20px;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: bold;
}

.filter {
    z-index: 1;
    position: absolute;
    top: 200px;
    right: 10px;
    width: 250px;
    height: 130px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border-radius: 6px;
    opacity: 1; 
}

.idLbl{
    cursor: pointer;
    /* margin-left: 5px; */
    color: #2C906B;
    font-weight: bold;
}

.idDiv{
    z-index: 2;
    position: absolute;
    top: 30px;
    left: 10px;
    bottom: 10px;
    width: 186px;
    height: 58px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border-radius: 6px;
    opacity: 1;
    display: block;
    padding-top: 10px;
}


.itinerary-details{
    max-height: calc(80vh - 10px);
    z-index: 2;
    position: absolute;
    top: 30px;
    left: 10px;
    bottom: 10px;
    width: 250px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 5px 10px #0000001A;
    border-radius: 6px;
    opacity: 1;
}

.box {   
    height: 18px; 
    border-radius: 4px;
    opacity: 1;  
}

#blue {
    background: #3C8BE8 0% 0% no-repeat padding-box;
    padding-left: 16px;
}

#red {
    background: #FF396C 0% 0% no-repeat padding-box;
    padding-left: 16px;
}

#purple {
    background: #C57AA9 0% 0% no-repeat padding-box;
    padding-left: 16px;
}

.line1 {
    margin-left: 20px;
}

.line2, .line3 {
    margin-left: 20px;
    margin-top: 10px;
}

.text{
    padding-left: 10px;
    font-size: 16px;
    /* color: var(--unnamed-color-3b3b3b); */
    text-align: left;
    /* font: normal normal normal 16px/18px Helvetica Neue; */
    letter-spacing: 0px;
    color: #3B3B3B;
    opacity: 1;
}

.d-inline-block{
    margin-left: 20px !important;    
}
#locationMenu{
    width: 210px !important;
    text-align: left;
}
.dropdown-toggle::after{
    position: absolute;
    top: 50%;
    right: 5%;
}

.ol-popup {
    position: absolute;
    background-color: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.2);
    padding: 15px;
    border-radius: 10px;
    border: 1px solid #cccccc;
    bottom: 12px;
    left: -50px;
    min-width: 340px;
}
.ol-popup:after, .ol-popup:before {
    top: 100%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
}
.ol-popup:after {
    border-top-color: white;
    border-width: 10px;
    left: 48px;
    margin-left: -10px;
}
.ol-popup:before {
    border-top-color: #cccccc;
    border-width: 11px;
    left: 48px;
    margin-left: -11px;
}
.ol-popup-closer {
    text-decoration: none;
    position: absolute;
    top: 5px;
    right: 10px;
    cursor: pointer;
}
/**.ol-popup-closer:after {
    content: "✖";
}*/
.ol-popup-closer{
    position: absolute;
    z-index: 1;
    top: 5px;
    right:5px;
    width: 30px;
    height: 30px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    border: none;
    background-image: url('close-button.svg');
    background-position: center;
}
    

.field{
    font-weight: bold;
    color: #2C906B;
}
.popup-content{
    font-size: 13.5px;
}


@media only screen and (max-width: 1940px) {
    .map {
        height: 84vh !important;
        width: 100%;
    }
}

@media only screen and (max-width: 1710px) {
    .map {
        height: 82vh !important;
        width: 100%;
    }
}

/**mac screen*/
@media only screen and (max-width: 1580px) {
    .map {
        height: 84vh !important;
        width: 100%;
    }
}

@media only screen and (max-width: 1430px) {
    .map {
        height: 79vh !important;
        width: 100%;
    }
}

/**mac screen*/
@media only screen and (max-width: 1390px) {
    .map {
        height: 82vh !important;
        width: 100%;
    }
}

/**mac screen*/
@media only screen and (max-width: 1310px) {
    .map {
        height: 80vh !important;
        width: 100%;
    }
}

@media only screen and (max-width: 1290px) {
    .map {
        height: 76vh !important;
        width: 100%;
    }
}

/**mac screen*/
@media only screen and (max-width: 1160px) {
    .map {
        height: 80vh !important;
        width: 100%;
    }
}

/**mac screen*/
@media only screen and (max-width: 1040px) {
    .map {
        height: 76vh !important;
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/core/hht/itinerary-map/itinerary-map.component.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;IACtB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;AAUA;IACI,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,0BAA0B;;AAE9B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;IACxC,gBAAgB;IAChB,uDAAuD;IACvD,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iBAAiB;AACrB;;;AAGA;IACI,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,mEAAmE;IACnE,+CAA+C;IAC/C,kCAAkC;IAClC,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,wCAAwC;IACxC,gBAAgB;IAChB,yDAAyD;IACzD,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,SAAS;IACT,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,UAAU;IACV,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,eAAe;AACnB;AACA;;EAEE;AACF;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,mEAAmE;IACnE,+CAA+C;IAC/C,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yCAA8D;IAC9D,2BAA2B;AAC/B;;;AAGA;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,iBAAiB;AACrB;;;AAGA;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA,cAAc;AACd;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA,cAAc;AACd;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA,cAAc;AACd;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA,cAAc;AACd;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ;;AAEA,cAAc;AACd;IACI;QACI,uBAAuB;QACvB,WAAW;IACf;AACJ","sourcesContent":[".map {\n    height: 80vh;\n    width: 100%;\n    /**width: 94em;*/\n    z-index: 0;\n}\n\n.map-error{\n    z-index: 1;\n    position: absolute;\n    top: 20%;\n    right: 42%;\n    left: 42%;\n    width: 200px;\n    height: 100px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #3836361a;\n    border-radius: 6px;\n    opacity: 1; \n    text-align: center;\n    padding-top: 3%;\n    color: #2C906B;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.ol-full-screen{\n    right: .5em !important;\n    top: 20em !important;\n    position: absolute;\n}\n\n.ol-zoom{\n    right: .5em !important;\n    top: 22em !important;\n    left: unset;\n    position: absolute;\n}\n\n.location-container:-webkit-full-screen {\n    height: 100%;\n    margin: 0;\n  }\n.location-container:-ms-fullscreen {\n    height: 100%;\n}\n\n.location-container:fullscreen {\n    height: 100%;\n}\n\n.location-container:fullscreen .map{\n    height: 100vh !important;\n}\n\n.location-container{\n    display: flex;\n    position: relative;\n    width: 100%;\n}\n\n.legend {\n    z-index: 1;\n    position: absolute;\n    top: 30px;\n    right: 10px;\n    width: 250px;\n    height: 250px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1; \n}\n\n.legendDiv{\n    z-index: 1;\n    position: absolute;\n    top: 30px;\n    right: 10px;\n    width: 133px;\n    height: 58px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1; \n    display: block;\n    padding: 10px 0px 10px 0px;\n\n}\n\n.legendLbl{\n    cursor: pointer;\n    /* margin-left: 5px; */\n    color: #2C906B;\n    font-weight: bold;\n}\n\n.text-desc{\n    width: 65px;\n    height: 19px;\n    /* color: var(--unnamed-color-2c906b); */\n    text-align: left;\n    /* font: normal normal bold 16px/19px Helvetica Neue; */\n    letter-spacing: 0px;\n    color: #2C906B;\n    opacity: 1;\n    margin-left: 20px;\n    margin-top: 20px;\n    margin-bottom: 20px;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.filter {\n    z-index: 1;\n    position: absolute;\n    top: 200px;\n    right: 10px;\n    width: 250px;\n    height: 130px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1; \n}\n\n.idLbl{\n    cursor: pointer;\n    /* margin-left: 5px; */\n    color: #2C906B;\n    font-weight: bold;\n}\n\n.idDiv{\n    z-index: 2;\n    position: absolute;\n    top: 30px;\n    left: 10px;\n    bottom: 10px;\n    width: 186px;\n    height: 58px;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1;\n    display: block;\n    padding-top: 10px;\n}\n\n\n.itinerary-details{\n    max-height: calc(80vh - 10px);\n    z-index: 2;\n    position: absolute;\n    top: 30px;\n    left: 10px;\n    bottom: 10px;\n    width: 250px;\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1;\n}\n\n.box {   \n    height: 18px; \n    border-radius: 4px;\n    opacity: 1;  \n}\n\n#blue {\n    background: #3C8BE8 0% 0% no-repeat padding-box;\n    padding-left: 16px;\n}\n\n#red {\n    background: #FF396C 0% 0% no-repeat padding-box;\n    padding-left: 16px;\n}\n\n#purple {\n    background: #C57AA9 0% 0% no-repeat padding-box;\n    padding-left: 16px;\n}\n\n.line1 {\n    margin-left: 20px;\n}\n\n.line2, .line3 {\n    margin-left: 20px;\n    margin-top: 10px;\n}\n\n.text{\n    padding-left: 10px;\n    font-size: 16px;\n    /* color: var(--unnamed-color-3b3b3b); */\n    text-align: left;\n    /* font: normal normal normal 16px/18px Helvetica Neue; */\n    letter-spacing: 0px;\n    color: #3B3B3B;\n    opacity: 1;\n}\n\n.d-inline-block{\n    margin-left: 20px !important;    \n}\n#locationMenu{\n    width: 210px !important;\n    text-align: left;\n}\n.dropdown-toggle::after{\n    position: absolute;\n    top: 50%;\n    right: 5%;\n}\n\n.ol-popup {\n    position: absolute;\n    background-color: white;\n    box-shadow: 0 1px 4px rgba(0,0,0,0.2);\n    padding: 15px;\n    border-radius: 10px;\n    border: 1px solid #cccccc;\n    bottom: 12px;\n    left: -50px;\n    min-width: 340px;\n}\n.ol-popup:after, .ol-popup:before {\n    top: 100%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n}\n.ol-popup:after {\n    border-top-color: white;\n    border-width: 10px;\n    left: 48px;\n    margin-left: -10px;\n}\n.ol-popup:before {\n    border-top-color: #cccccc;\n    border-width: 11px;\n    left: 48px;\n    margin-left: -11px;\n}\n.ol-popup-closer {\n    text-decoration: none;\n    position: absolute;\n    top: 5px;\n    right: 10px;\n    cursor: pointer;\n}\n/**.ol-popup-closer:after {\n    content: \"✖\";\n}*/\n.ol-popup-closer{\n    position: absolute;\n    z-index: 1;\n    top: 5px;\n    right:5px;\n    width: 30px;\n    height: 30px;\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    border: none;\n    background-image: url(../../../../assets/img/close-button.svg);\n    background-position: center;\n}\n    \n\n.field{\n    font-weight: bold;\n    color: #2C906B;\n}\n.popup-content{\n    font-size: 13.5px;\n}\n\n\n@media only screen and (max-width: 1940px) {\n    .map {\n        height: 84vh !important;\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 1710px) {\n    .map {\n        height: 82vh !important;\n        width: 100%;\n    }\n}\n\n/**mac screen*/\n@media only screen and (max-width: 1580px) {\n    .map {\n        height: 84vh !important;\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 1430px) {\n    .map {\n        height: 79vh !important;\n        width: 100%;\n    }\n}\n\n/**mac screen*/\n@media only screen and (max-width: 1390px) {\n    .map {\n        height: 82vh !important;\n        width: 100%;\n    }\n}\n\n/**mac screen*/\n@media only screen and (max-width: 1310px) {\n    .map {\n        height: 80vh !important;\n        width: 100%;\n    }\n}\n\n@media only screen and (max-width: 1290px) {\n    .map {\n        height: 76vh !important;\n        width: 100%;\n    }\n}\n\n/**mac screen*/\n@media only screen and (max-width: 1160px) {\n    .map {\n        height: 80vh !important;\n        width: 100%;\n    }\n}\n\n/**mac screen*/\n@media only screen and (max-width: 1040px) {\n    .map {\n        height: 76vh !important;\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
